import MuiGrey from '@mui/material/colors/grey';
import MuiYellow from '@mui/material/colors/yellow';
import MuiGreen from '@mui/material/colors/green';
import MuiBlue from '@mui/material/colors/blue';
import MuiOrange from '@mui/material/colors/orange';
import MuiRed from '@mui/material/colors/red';
import MuiCyan from '@mui/material/colors/cyan';
import MuiPink from '@mui/material/colors/pink';
import MuiPurple from '@mui/material/colors/purple';
import MuiBlueGrey from '@mui/material/colors/blueGrey';
import MuiTeal from '@mui/material/colors/teal';


const purple = {
  ...MuiPurple,
  50: '#F0ECFB',
  100: '#E2D8F6',
  200: '#C4B1ED',
  300: '#A78BE5',
  400: '#8964DC',
  500: '#6C3DD3',
  600: '#6137BE',
  700: '#5631A9',
  800: '#5631A9',
  900: '#2B1854',
};

const yellow = {
  ...MuiYellow,
  50: '#FEFAED',
  100: '#FEF5DA',
  200: '#FDEBB5',
  300: '#FBE290',
  400: '#F9CE46',
  500: '#F9CE46',
  600: '#C7A538',
  700: '#957C2A',
  800: '#64521C',
  900: '#4B3E15',
};

const green = {
  ...MuiGreen,
  50: '#E4FBED',
  100: '#C8F7DA',
  200: '#ADF4C8',
  300: '#76ECA3',
  400: '#91F0B5',
  500: '#5EBD82',
  600: '#478E62',
  700: '#3B7651',
  800: '#2F5E41',
  900: '#2F5E41'
};

const blue = {
  ...MuiBlue,
  50: '#BAD8FC',
  100: '#95C3FA',
  200: '#6EAEF8',
  300: '#4599F6',
  400: '#2184F4',
  500: '#0D79F3',
  600: '#0870DF',
  700: '#0C65CC',
  800: '#0A5BB8',
  900: '#0852A5',
};

const teal = {
  ...MuiTeal,
  50: '#E9FCFF',
  100: '#D2F9FF',
  200: '#A5F3FF',
  300: '#78EDFF',
  400: '#4CE6FF',
  500: '#1FE0FF',
  600: '#19B3CC',
  700: '#138699',
  800: '#0C5A66',
  900: '#09434D',
};

const orange = {
  ...MuiOrange,
  50: '#FFF3ED',
  100: '#FFE6DA',
  200: '#FFCDB5',
  300: '#FFB491',
  400: '#FF9B6C',
  500: '#FF8247',
  600: '#994E2B',
  700: '#994E2B',
  800: '#66341C',
  900: '#4D2715',
};

const red = {
  ...MuiRed,
  50: '#FCBFBB',
  100: '#FB9893',
  200: '#FA766C',
  300: '#F85244',
  400: '#F7201D',
  500: '#F61809',
  600: '#E31808',
  700: '#CF1607',
  800: '#BC1407',
  900: '#AB1206',
};

const grey = {
  ...MuiGrey,
  50: '#e9ebf0',
  100: '#c7cddb',
  200: '#a4adc3',
  300: '#818da9',
  400: '#677498',
  500: '#4e5c89',
  600: '#475480',
  700: '#3f4a74',
  800: '#384167',
  900: '#2c314e',
};

const coral = {
  ...MuiOrange,
  50: '#fbebe8',
  100: '#ffd1be',
  200: '#ffb495',
  300: '#ff9769',
  400: '#ff8147',
  500: '#ff6e25',
  600: '#f46721',
  700: '#e6601c',
  800: '#d85919',
  900: '#c04c11',
};

const cyan = {
  ...MuiCyan,
  50: '#e1f7fd',
  100: '#b5ebf8',
  200: '#84dff4',
  300: '#55d1ed',
  400: '#35c7e7',
  500: '#26bee0',
  600: '#21aecd',
  700: '#1999b2',
  800: '#138599',
  900: '#07626d',
};

const pink = {
  ...MuiPink,
  50: '#FEF1F6',
  100: '#FDE4ED',
  200: '#FAC8DC',
  300: '#F8ADCA',
  400: '#F691B9',
  500: '#F476A7',
  600: '#C35E86',
  700: '#924764',
  800: '#622F43',
  900: '#492332'
};

const navy = {
  ...MuiBlueGrey,
  50: '#FFFFFF',
  100: '#FAFBFC',
  200: '#F6F7F9',
  300: '#EDEEF2',
  400: '#E4E6EC',
  500: '#D2D5E0',
  600: '#A2A9BE',
  700: '#757F9F',
  800: '#475480',
  900: '#041245',
};

const common = {
  black: '#000',
  white: '#fff'
}

const secondary = {
  main: navy[700],
}

const primary = {
  main: navy[900],
  light: navy[700],
  dark: navy[900],
  contrastText: common.white,
}

const success = {
  main: green[500],
}

const error = {
  main: red[500],
}

const warning = {
  main: yellow[500],
}

const info = {
  main: blue[500],
}

const text = {
  primary: navy[800],
  secondary: navy[600],
  disabled: '#E8E9EE',
}

const divider = navy[400];

export {
  purple,
  green,
  // functional color
  common,
  secondary,
  primary,
  success,
  error,
  warning,
  info,
  text,
  divider,
  grey,
  orange,
  red,
  blue,
  coral,
  cyan,
  pink,
  yellow,
  navy,
  teal
};
